import { useMemo } from 'react';
import type { BaoCaoSoDuCongNoItem } from '@/types/schemas';
import { TableData } from '@/components/custom/erp';
import { formatMoney } from '@/lib/formatUtils';

export interface UseTableDataReturn {
  tables: TableData[];
  handleRowClick: (params: MuaHangRecord) => void;
}

export function useTableData(data: BaoCaoSoDuCongNoItem[]): UseTableDataReturn {
  const calculateTotals = (items: BaoCaoSoDuCongNoItem[]) => {
    return items.reduce(
      (totals, item) => {
        return {
          du_no: totals.du_no + (item.du_no || 0),
          du_co: totals.du_co + (item.du_co || 0)
        };
      },
      {
        du_no: 0,
        du_co: 0
      }
    );
  };

  const tables = useMemo(() => {
    const tableData: TableData[] = [
      {
        name: '',
        columns: [
          {
            field: 'ma_kh',
            headerName: 'Mã NCC',
            width: 130
          },
          {
            field: 'ten_kh',
            headerName: 'Tên nhà cung cấp',
            width: 250,
            cellClassName: (params: MuaHangRecord) => (params.row.is_total ? 'font-extrabold' : '')
          },

          {
            field: 'du_no',
            headerName: 'Dư nợ',
            width: 140,
            type: 'number',
            cellClassName: (params: MuaHangRecord) => (params.row.is_total ? 'font-extrabold' : ''),
            renderCell: (params: MuaHangRecord) => {
              return params.row.du_no > 0 ? formatMoney(params.row.du_no) : '';
            }
          },
          {
            field: 'du_co',
            headerName: 'Dư có',
            width: 140,
            type: 'number',
            cellClassName: (params: MuaHangRecord) => (params.row.is_total ? 'font-extrabold' : ''),
            renderCell: (params: MuaHangRecord) => {
              return params.row.du_co > 0 ? formatMoney(params.row.du_co) : '';
            }
          }
        ],
        rows: [...data]
      }
    ];

    return tableData;
  }, [data]);

  const handleRowClick = (params: MuaHangRecord) => {
    console.log('Row clicked:', params);
  };

  return {
    tables,
    handleRowClick
  };
}
